/** Avis des clients : réservés à qui les lit (décision du 12/10/2026). */
import { lazy } from 'react';
import type { AppRoute } from '../../app/route-types.js';

const FeedbackOverviewPage = lazy(() => import('./FeedbackOverviewPage.js').then((m) => ({ default: m.FeedbackOverviewPage })));

export const feedbackRoutes: AppRoute[] = [
  { path: '/avis-clients', element: <FeedbackOverviewPage />, gate: { anyOf: ['feedback.view'] } },
];
